export default __webpack_public_path__ + "static/media/assign_member.77fcdd89.png";